/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cases_Col_Sla_StatusInputs */

const en_cases_col_sla_status = /** @type {(inputs: Cases_Col_Sla_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SLA`)
};

const pt_br2_cases_col_sla_status = /** @type {(inputs: Cases_Col_Sla_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SLA`)
};

/**
* | output |
* | --- |
* | "SLA" |
*
* @param {Cases_Col_Sla_StatusInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const cases_col_sla_status = /** @type {((inputs?: Cases_Col_Sla_StatusInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cases_Col_Sla_StatusInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_cases_col_sla_status(inputs)
	return pt_br2_cases_col_sla_status(inputs)
});